import axAPI from 'httpConfig'

class PsvApiService {
	static getPsvDynamicData = async (startDate: number, endDate: number) => {
		return axAPI.get(`groups/psv?start=${startDate}&end=${endDate}`)
	}
}

export default PsvApiService
